<template>
  <div class="policies data--cards">
    <div class="page__header">
      <div class="page__title">
        {{ $t('policies.title') }}
     
      </div>
      <div class="page__right">
        <div class="selected-filters"
          v-if="selectedTeamIds.length > 0 || (searchPoliciesForms && Object.keys(searchPoliciesForms).length > 0)">

          <div v-for="teamId in selectedTeamIds" :key="`team${teamId}`" class="selected-filters__filter">
            <span>Team: {{ getTeamDisplayName(teamId) }}</span>
            <div class="selected-filters__remove" @click="removeTeam(teamId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="startDateFrom || startDateTo">
            <span>{{ $t('searchCustomerFields.policyStartDate') }}: {{ formatDateShort(startDateFrom) || '...' }} - {{
              formatDateShort(startDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearStartDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="endDateFrom || endDateTo">
            <span>{{ $t('searchCustomerFields.policyEndDate') }}: {{ formatDateShort(endDateFrom) || '...' }} - {{
              formatDateShort(endDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearEndDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="submitDateFrom || submitDateTo">
            <span>{{ $t('searchCustomerFields.policySubmitDate') }}: {{ formatDateShort(submitDateFrom) || '...' }} - {{
              formatDateShort(submitDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearSubmitDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-for="agentId in selectedAgents" :key="`agent${agentId}`">
            <span>Agent: 
              {{
                (searchPoliciesForms.agents && searchPoliciesForms.agents.find(a => a.id == agentId))
                  ? searchPoliciesForms.agents.find(a => a.id == agentId).first_name + ' ' +
                  searchPoliciesForms.agents.find(a => a.id == agentId).last_name
                  : 'Agent ' + agentId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeAgent(agentId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="companyId in selectedCompanies" :key="`company${companyId}`">
            Company: {{
              searchPoliciesForms.companies?.find(
                (item) => item.id === companyId
              )?.name
            }}
            <div class="selected-filters__remove" @click="removeCompany(companyId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="statusId in selectedPolicyStatuses" :key="`status${statusId}`">
            <span>Policy Status: {{
              searchPoliciesForms.policyStatuses?.find(
                (item) => item.id === statusId
              )?.[`name`]
            }}</span>
            <div class="selected-filters__remove" @click="removePolicyStatus(statusId)"></div>
          </div>
        </div>

        <form class="search search--filter" @submit.prevent="keywordsSearch()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = !showSearchFilter"></div>
          <SearchFilter v-if="showSearchFilter" :searchType="'policy'" :filterToggler="filterToggler"
            :toggleSearchFilter="(state) => {
              showSearchFilter = state;
            }
              " />
        </form>
      </div>
    </div>

    <div class="data_content">
      <Loading v-if="policiesLoading" />
      <div v-else>
        <NoData v-if="policyCollectionError?.status === 403" style="height: 80vh;" type="no-permission" />
        <NoData style="height: 80vh;" :type="'policiesList'"
          v-else-if="!policiesPerPage.data || policiesPerPage.data.length == 0" />
        <div v-else class="table">
          <div></div>
          <div class="table__header box box--default">
            <div class="table__label table__label--small" style="padding-right: 0 !important;"></div>
            <div class="table__label table__label--large">
              {{ $t('policies.tableHead.insurance') }}
            </div>

            <div class="table__label table__label--medium">
              {{ $t('policies.tableHead.plateNr') }}
            </div>

            <div class="table__label table__label--large">
              {{ $t('policies.tableHead.company') }}
            </div>
            <div class="table__label table__label--small">
              {{ $t('policies.tableHead.status') }}
            </div>
            <div class="table__label table__label--large">
              {{ $t('policies.tableHead.customer') }}
            </div>
            <div class="table__label table__label--medium">
              {{ $t('policies.tableHead.policyNr') }}
            </div>
            <div class="table__label table__label--medium">
              {{ $t('policies.tableHead.created') }}
            </div>
            <div class="table__label table__label--large">
              {{ $t('policies.tableHead.agent') }}
            </div>
            <div class="table__label table__label--small" style="padding: 0 !important;">
            </div>
            <div class="table__label table__label--small" style="padding: 0 !important;">
            </div>

          </div>

          <div class="table__body">
            <div class="data-record" v-for="policy in policiesPerPage.data" :key="policy.id">
              <div v-if="!isMobileView" class="row policy-row row--hover box box--default"
                :class="[policy.policy_status ? `policy--${policy.policy_status.name}` : '']"
                @click="goToCustomer(policy)">
                <div class="row__data row__data--small policy-icon" style="padding-right: 0 !important;">
                  <div :class="[
                    'icon',
                    `icon__policy--${policy.policy_services.find(s => s.service && s.service.id === selectedPolicies[policy.id])
                      ? policy.policy_services.find(s => s.service && s.service.id === selectedPolicies[policy.id]).service.branch_category.id
                      : 'krankenkasse'
                    }`
                  ]">
                  </div>
                </div>

                <div class="row__data row__data--large">
                  <div v-if="policy.policy_services && policy.policy_services.length > 0"
                    style="width: 100%;  text-align: center;">
                    <VSelect @click.stop v-if="policy.policy_services.length > 1" style="width: 100%; background: 0;"
                      :options="policy.policy_services.filter(s => s.service && s.service.branch_category).map(s => ({
                        label: s.service.branch_category.name,
                        value: s.service.id
                      }))" label="label" :reduce="option => option.value"
                      class="select select--default customer__dropdown" v-model="selectedPolicies[policy.id]" />

                    <span v-else>
                      {{ policy.policy_services[0].service && policy.policy_services[0].service.branch_category ?
                        policy.policy_services[0].service.branch_category.name : '------' }}
                    </span>

                  </div>
                  <span v-else>------</span>
                </div>

                <div class="row__data row__data--name row__data--medium">
                  <span v-if="policy.plate_number">{{ policy.plate_number }} </span>
                  <span v-else>------</span>
                </div>


                <div class="row__data row__data--name row__data--large">
                  <div v-if="policy.company">
                    <p>{{ policy.company.full_name }}</p>
                  </div>
                  <div v-else>------</div>
                </div>
                <div class="row__data row__data--small">
                  <div v-if="policy.policy_status">
                    <p>{{ policy.policy_status.name }}</p>
                  </div>
                  <div v-else>------</div>
                </div>
                <div class="row__data row__data--name row__data--large">
                  <div v-if="policy.customer">
                    <span v-if="policy.customer.company_name">
                      {{ policy.customer.company_name }}
                    </span>
                    <span v-else>
                      {{ policy.customer.first_name }} {{ policy.customer.last_name }}
                    </span>
                  </div>
                  <div v-else>------</div>
                </div>
                <div class="row__data row__data--medium">
                  <div v-if="policy.policy_number">
                    <p>{{ policy.policy_number }}</p>
                  </div>
                  <div v-else>------</div>
                </div>
                <div class="row__data row__data--medium">
                  <div>
                    <p>{{ formatDate(policy.created_at) }}</p>
                  </div>
                </div>
                <div class="row__data row__data--name row__data--large">
                  <div v-if="policy.agent">
                    {{ policy.agent.first_name }} {{ policy.agent.last_name }}
                  </div>
                  <div v-else>------</div>
                </div>
                <div class="row__data row__data--small row__data--pdf" @click.stop style="padding: 0 !important;">
                  <div v-if="canShowPolicy(policy)" @click="openPolicyFilesModal(policy.id, policy.policy_files, policy.customer_id)"
                    class="icon icon__pdf"
                    :class="{ 'icon__pdf--active': policy.policy_files && policy.policy_files.length }"></div>
                </div>
                <div class="row__data row__data--action row__data--small" style="padding: 0 !important;"></div>
              </div>

              <article v-if="isMobileView" class="data-card box box--default">
                <header class="data-card__header">
                  <button type="button" class="data-card__identity" @click.stop="goToCustomer(policy)">
                    <span class="data-card__avatar" :style="{ borderColor: getPolicyStatusColor(policy) }">
                      <span :class="['icon', getPolicyIconClass(policy)]"></span>
                    </span>
                    <span class="data-card__name">{{ getPolicyInsuranceName(policy) }}</span>
                  </button>

                  <div 
                    class="data-card__action row__data--action" 
                    role="button" 
                    tabindex="0" 
                    @click.stop="goToCustomer(policy)"
                  > 
                  </div>
                </header>

                <dl class="data-card__details">
                  <div v-if="policy.plate_number" class="data-card__detail">
                    <dt>{{ $t('policies.tableHead.plateNr') }}</dt>
                    <dd>{{ policy.plate_number }}</dd>
                  </div>
                  <div v-if="policy.company?.full_name || policy.company?.name" class="data-card__detail data-card__detail-full">
                    <dt>{{ $t('policies.tableHead.company') }}</dt>
                    <dd>{{ policy.company?.full_name || policy.company?.name }}</dd>
                  </div>
                  <div v-if="policy.policy_status?.name" class="data-card__detail">
                    <dt>{{ $t('policies.tableHead.status') }}</dt>
                    <dd>{{ policy.policy_status.name }}</dd>
                  </div>
                  <div v-if="getPolicyCustomerName(policy)" class="data-card__detail">
                    <dt>{{ $t('policies.tableHead.customer') }}</dt>
                    <dd>{{ getPolicyCustomerName(policy) }}</dd>
                  </div>
                  <div v-if="policy.policy_number" class="data-card__detail">
                    <dt>{{ $t('policies.tableHead.policyNr') }}</dt>
                    <dd>{{ policy.policy_number }}</dd>
                  </div>
                  <div v-if="policy.created_at" class="data-card__detail">
                    <dt>{{ $t('policies.tableHead.created') }}</dt>
                    <dd>{{ formatDate(policy.created_at) }}</dd>
                  </div>
                  <div v-if="getPolicyAgentName(policy)" class="data-card__detail">
                    <dt>{{ $t('policies.tableHead.agent') }}</dt>
                    <dd>{{ getPolicyAgentName(policy) }}</dd>
                  </div>
                </dl>
              </article>
            </div>
          </div>

          <Pagination :limit="3" :data="policiesPerPage" @pagination-change-page="getResults"></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import SearchFilter from "@/partials/SearchFilter";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
//import RowActionDropdown from "@/components/RowActionDropdown";

const store = useStore();
const route = useRoute();
const router = useRouter();

// Template refs
const search = ref(null);
const filterToggler = ref(null);

// Reactive data
const searchKeywords = ref("");
const showSearchFilter = ref(false);
const selectedTeamIds = ref([]);
const selectedTeamId = computed(() => selectedTeamIds.value.length > 0 ? selectedTeamIds.value[0] : null);
const selectedAgents = ref([]);
const selectedCompanies = ref([]);
const selectedBranchCategories = ref([]);
const selectedPolicyStatuses = ref([]);
const selectedPolicies = ref({});
const startDateFrom = ref("");
const startDateTo = ref("");
const endDateFrom = ref("");
const endDateTo = ref("");
const submitDateFrom = ref("");
const submitDateTo = ref("");
const initialLoadDone = ref(false);
// const showCardActionsDropdown = ref({});

const isMobileView = ref(false);

// Computed properties
const policiesPerPage = computed(() => store.getters.policiesPerPage);
const policiesLoading = computed(() => store.getters.policiesLoading);
const searchPoliciesForms = computed(() => store.getters.searchPoliciesForms); 
const policyCollectionError = computed(() => store.getters.policyCollectionError); 
const showPolicyFilesModal = computed(() => store.getters.showPolicyFilesModal);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);

const canAccessPolicies = computed(() => {
  if (isSuperAdmin.value) return true;

  const authorizedTeams = store.getters.authorizedTeamIds('policy_access');
  return authorizedTeams === null || (Array.isArray(authorizedTeams) && authorizedTeams.length > 0);
});

const updateMobileView = () => {
  isMobileView.value = window.innerWidth <= 900;
};

// Watchers
watch(
  () => showPolicyFilesModal.value,
  (newVal) => {
    // When modal closes (newVal becomes false), refresh the table
    if (!newVal) {
      searchPolicies();
    }
  }
);

// Methods
const searchPolicies = async () => {
  const q = route.query;
  const page = Number(q.page) || 1;

  const agents = q.agents ? q.agents.split(",").map(Number) : [];
  const companies = q.companies ? q.companies.split(",").map(Number) : [];
  const policyStatuses = q.policyStatuses ? q.policyStatuses.split(",").map(Number) : [];
  const branchCategories = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];

  await store.dispatch("searchPolicies", {
      page,
      teamId: selectedTeamIds.value.length > 0 ? selectedTeamIds.value : null,
      agents,
      companies,
      branchCategories,
      policyStatuses,
      search: q.search || "",
      startDateFrom: q.startDateFrom || "",
      startDateTo: q.startDateTo || "",
      endDateFrom: q.endDateFrom || "",
      endDateTo: q.endDateTo || "",
      submitDateFrom: q.submitDateFrom || "",
      submitDateTo: q.submitDateTo || "",
  });
};

const loadFiltersFromQuery = async (q) => {
  searchKeywords.value = q.search || "";
  // Handle teams parameter (can be array or string) - store all teams
  const normalizedTeamIds = Array.isArray(q.teams)
    ? q.teams
    : typeof q.teams === 'string' && q.teams.length
      ? q.teams.split(',')
      : [];

  selectedTeamIds.value = normalizedTeamIds
    .flatMap((teamId) => String(teamId).split(','))
    .map((teamId) => Number(teamId))
    .filter((teamId) => Number.isInteger(teamId) && teamId > 0);
  selectedAgents.value = q.agents ? q.agents.split(",").map(Number) : [];
  selectedCompanies.value = q.companies ? q.companies.split(",").map(Number) : [];
  selectedBranchCategories.value = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];
  selectedPolicyStatuses.value = q.policyStatuses ? q.policyStatuses.split(",").map(Number) : [];
  startDateFrom.value = q.startDateFrom || "";
  startDateTo.value = q.startDateTo || "";
  endDateFrom.value = q.endDateFrom || "";
  endDateTo.value = q.endDateTo || "";
  submitDateFrom.value = q.submitDateFrom || "";
  submitDateTo.value = q.submitDateTo || "";
};

const removePolicyStatus = (id) => {
  selectedPolicyStatuses.value = selectedPolicyStatuses.value.filter((x) => x !== id);
  updateQuery();
};

const removeAgent = (id) => {
  selectedAgents.value = selectedAgents.value.filter((x) => x !== id);
  updateQuery();
};

const removeCompany = (id) => {
  selectedCompanies.value = selectedCompanies.value.filter((x) => x !== id);
  updateQuery();
};

const clearStartDateRange = () => {
  startDateFrom.value = "";
  startDateTo.value = "";
  updateQuery();
};

const clearEndDateRange = () => {
  endDateFrom.value = "";
  endDateTo.value = "";
  updateQuery();
};

const clearSubmitDateRange = () => {
  submitDateFrom.value = "";
  submitDateTo.value = "";
  updateQuery();
};

const removeTeam = (teamId) => {
  selectedTeamIds.value = selectedTeamIds.value.filter(id => id !== teamId);
  if (selectedTeamIds.value.length === 0) {
    clearAllDependentFilters();
  }
  updateQuery();
};

const clearAllDependentFilters = () => {
  selectedAgents.value = [];
  selectedCompanies.value = [];
  selectedBranchCategories.value = [];
  selectedPolicyStatuses.value = [];
  startDateFrom.value = "";
  startDateTo.value = "";
  endDateFrom.value = "";
  endDateTo.value = "";
  submitDateFrom.value = "";
  submitDateTo.value = "";

  store.commit("setSearchPoliciesForms", {});
};

const policyTeamId = (policy) => Number(policy?.team_id || policy?.team?.id || policy?.customer?.team_id || policy?.customer?.team?.id) || null;
const canShowPolicy = (policy) => {
  if (isSuperAdmin.value) return true;

  const result = store.getters.hasTeamPermission("policy_show", policyTeamId(policy));
  if (!result) {
    return;
  }
  return result;
};

const goToCustomer = (policy) => {
  if (!canShowPolicy(policy)) return;
  if (policy.customer && policy.customer.id) {
    router.push(`/account-details/customer/${policy.customer.id}/policy/${policy.id}`);
  } else {
    router.push(`/account-details/customer/${policy.customer_id}/policy/${policy.id}`);
  }
};

const openPolicyFilesModal = (id, files, customerId) => {
  const authorizedTeams = store.getters.authorizedTeamIds('policy_create');
  const hasPermissionToCreatePolicy = isSuperAdmin.value
    || authorizedTeams === null
    || (Array.isArray(authorizedTeams) && authorizedTeams.length > 0);

  if (!hasPermissionToCreatePolicy) return;

  store.commit("setPolicyFileId", id);
  store.commit("setPolicyFiles", files);
  store.commit("setCustomerFromDashboard", customerId);
  store.commit("setFilesFromDashboard", true);
  store.commit("setShowPolicyFilesModal", true);
};

const getPolicyInsuranceName = (policy) => {
  if (!policy.policy_services?.length) return "------";

  const selectedServiceId = selectedPolicies.value[policy.id];
  const selectedService = policy.policy_services.find((service) => service.service && service.service.id === selectedServiceId)
    || policy.policy_services[0];

  return selectedService?.service?.branch_category?.name || "------";
};

const getPolicyIconClass = (policy) => {
  if (!policy.policy_services?.length) return "icon__policy--krankenkasse";

  const selectedServiceId = selectedPolicies.value[policy.id];
  const selectedService = policy.policy_services.find((service) => service.service && service.service.id === selectedServiceId)
    || policy.policy_services[0];
  const categoryId = selectedService?.service?.branch_category?.id;

  return `icon__policy--${categoryId || 'krankenkasse'}`;
};

const getPolicyStatusColor = (policy) => {
  const statusName = (policy?.policy_status?.name || policy?.policy_status?.name || "").toLowerCase();

  if (statusName === "active") return "#22DB8E";
  if (statusName === "submitted" || statusName === "processing") return "#FF9E0F";
  if (statusName === "inactive") return "#DB2222";

  return "#7f8fa4";
};

const getPolicyCustomerName = (policy) => {
  if (!policy.customer) return "";

  if (policy.customer.company_name) return policy.customer.company_name;

  const fullName = `${policy.customer.first_name || ""} ${policy.customer.last_name || ""}`.trim();
  return fullName;
};

const getPolicyAgentName = (policy) => {
  if (!policy.agent) return "";

  return `${policy.agent.first_name || ""} ${policy.agent.last_name || ""}`.trim();
};

const getTeamDisplayName = (teamId) => {
  const resolvedTeamId = Number(teamId);
  if (!Number.isInteger(resolvedTeamId) || resolvedTeamId <= 0) {
    return 'All authorized teams';
  }

  const teamNameFromMembership = store.getters.membershipFor(resolvedTeamId)?.team?.name;
  if (teamNameFromMembership) return teamNameFromMembership;

  const teamNameFromAuthorizationMembership = Array.isArray(store.getters.authorizationMemberships)
    ? store.getters.authorizationMemberships.find((membership) => Number(membership?.team?.id) === resolvedTeamId)?.team?.name
    : null;
  if (teamNameFromAuthorizationMembership) return teamNameFromAuthorizationMembership;

  const teamNameFromList = Array.isArray(store.getters.teams)
    ? store.getters.teams.find((team) => Number(team?.id) === resolvedTeamId)?.name
    : null;
  if (teamNameFromList) return teamNameFromList;

  const userTeamName = Array.isArray(store.getters.loggedUser?.teams)
    ? store.getters.loggedUser.teams.find((team) => Number(team?.id) === resolvedTeamId)?.name
    : null;
  if (userTeamName) return userTeamName;

  const currentTeamId = Number(store.getters.currentTeamId);
  if (Number.isInteger(currentTeamId) && currentTeamId > 0 && currentTeamId === resolvedTeamId) {
    return store.getters.membershipFor(currentTeamId)?.team?.name || `Team ${resolvedTeamId}`;
  }

  return `Team ${resolvedTeamId}`;
};

const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

const formatDateShort = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
};

const updateQuery = () => {
  const query = {
    page: 1,
    search: searchKeywords.value || undefined,
      teams: selectedTeamIds.value.length > 0 ? selectedTeamIds.value : undefined,
    agents: selectedAgents.value.length ? selectedAgents.value.join(",") : undefined,
    companies: selectedCompanies.value.length ? selectedCompanies.value.join(",") : undefined,
    branchCategories: selectedBranchCategories.value.length ? selectedBranchCategories.value.join(",") : undefined,
    policyStatuses: selectedPolicyStatuses.value.length ? selectedPolicyStatuses.value.join(",") : undefined,
    startDateFrom: startDateFrom.value || undefined,
    startDateTo: startDateTo.value || undefined,
    endDateFrom: endDateFrom.value || undefined,
    endDateTo: endDateTo.value || undefined,
    submitDateFrom: submitDateFrom.value || undefined,
    submitDateTo: submitDateTo.value || undefined,
  };

  router.replace({ query }).catch(() => { });
};

const getResults = async (paginationPage) => {
  router.replace({
    query: { ...route.query, page: paginationPage },
  });
};

const keywordsSearch = async () => {
  updateQuery();
};

// Watchers
watch(
  () => policiesPerPage.value?.data,
  (newPolicies) => {
    if (!newPolicies || !Array.isArray(newPolicies)) return;

    newPolicies.forEach(policy => {
      if (!selectedPolicies.value[policy.id] && policy.policy_services && policy.policy_services.length > 0) {
        selectedPolicies.value[policy.id] = policy.policy_services[0].service.id;
      }
    });
  },
  { deep: true, immediate: true }
);

watch(
  () => route.query,
  async (query, oldQuery) => {
    if (!query.page) {
      router.replace({
        query: { ...query, page: 1 },
      }).catch(() => { });
      return;
    }

    if (oldQuery && JSON.stringify(query) === JSON.stringify(oldQuery)) {
      return;
    }

    loadFiltersFromQuery(query);
    if (query.teams !== oldQuery?.teams) {
      if (selectedTeamId.value !== null) {
        await store.dispatch("getSearchPoliciesForms", selectedTeamId.value);
      } else {
        store.commit("setSearchPoliciesForms", {});
      }
    }

    await searchPolicies();

    initialLoadDone.value = true;
  },
  { immediate: true, deep: true }
);

// Lifecycle
onMounted(async () => {
  updateMobileView();
  window.addEventListener("resize", updateMobileView);

  // Page-level access control
  if (!canAccessPolicies.value) {
    router.replace("/dashboard");
    return;
  }

  try {
    const isSuperAdminUser = Boolean(store.getters.isSuperAdmin);
    if (isSuperAdminUser && (!Array.isArray(store.getters.teams) || store.getters.teams.length === 0)) {
      await store.dispatch("getTeams");
    }

    let teamId = null;
    if (Array.isArray(route.query.teams)) {
      teamId = route.query.teams.length > 0 ? Number(route.query.teams[0]) : null;
    } else if (typeof route.query.teams === 'string' && route.query.teams.length) {
      teamId = Number(route.query.teams);
    }
    if (Number.isInteger(teamId) && teamId > 0) {
      await store.dispatch("getSearchPoliciesForms", teamId);
    }
  } catch (e) {
    console.error("Form Load Error", e);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateMobileView);
});
</script>


<style lang="scss" scoped>
.policy-row {
  position: relative;

  &::before {
    position: absolute;
    z-index: 3;
    content: "";
    left: 0;
    top: -1px;
    height: calc(100% + 2px);
    width: 15px;
    border-top-left-radius: var(--radius-1);
    border-bottom-left-radius: var(--radius-1);
  }
}

.policy--Active {
  &::before {
    background-color: #22DB8E;
  }
}

.policy--Submitted,
.policy--Processing {
  &::before {
    background-color: #FF9E0F;
  }
}

.policy--Inactive {
  &::before {
    background-color: #DB2222;
  }
}

.data-card__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 2px solid transparent;
  border-radius: 50%;
  background-color: var(--bg-3);

  .icon {
    width: 22px;
    height: 22px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 22px;
  }
}

.data-card__identity {
  gap: 10px;
}

.data-card__detail-full {
  grid-column: 1 / -1;
}
</style>
